import cx from 'classnames';
import React from 'react';

import styles from './style.module.scss';

export const JobApplicationStatusLabel = ({ status }) => {
  if (status === 'successful') {
    return (
      <div
        className={cx(styles.status, styles[status])}
        data-testid={'job-application-status-label'}
      >
        {'APPLICATION ACCEPTED'}
      </div>
    );
  }
  return (
    <div className={cx(styles.status, styles[status])} data-testid={'job-application-status-label'}>
      {status.toUpperCase()}
    </div>
  );
};
